// @flow
import * as React from 'react';
import { AsyncCreatable } from 'components/Select';
import ClientOnly from 'containers/ClientOnly';

const { useState } = React;

const makeOption = (v: string) => ({ value: v, label: v });

const MultiCreatableSelect = ({
  name,
  value,
  disabled,
  onChange,
  ...props
}: {
  name: string,
  value: Array<string>,
  disabled?: boolean,
  onChange: string => void,
  'data-qa-id'?: string
}) => {
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (v: string) => {
    setInputValue(v);
  };

  return (
    <ClientOnly>
      <AsyncCreatable
        name={name}
        inputValue={inputValue}
        value={value.map(makeOption)}
        isDisabled={disabled}
        onChange={newValues => {
          onChange(newValues.map(v => v.value));
        }}
        onInputChange={handleInputChange}
        isSearchable
        isClearable
        isMulti
        className={
          props['data-qa-id'] ? `qa-id-${props['data-qa-id']}` : undefined
        }
        {...props}
      />
    </ClientOnly>
  );
};

export default MultiCreatableSelect;
